import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'

// shared
import Navbar from './shared/navbar/Navbar'
import Message from './shared/components/FlashMessage/Message'
import PrivateRoute from './shared/privateRoute/PrivateRoute'

// pages
import Home from './pages/Home/Home'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import VerifyEmail from './pages/auth/VerifyEmail'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import Perfil from './pages/Perfil/Perfil'
import Ranking from './pages/Ranking/Ranking'
import Precos from './pages/Precos/Precos'
import PoliticaPrivacidade from './pages/PoliticaPrivacidade/PoliticaPrivacidade'
import ExclusaoConta from './pages/ExclusaoConta/ExclusaoConta'

// context
import { UserProvider } from './context/UserContext'

function AppLayout() {
  return (
    <>
      <Navbar />
      <div className="page-layout">
        <Message />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/cadastro" exact element={<Register />} />
          <Route path="/verificar-email" exact element={<VerifyEmail />} />
          <Route path="/esqueci-senha" exact element={<ForgotPassword />} />
          <Route path="/redefinir-senha" exact element={<ResetPassword />} />
          <Route path="/ranking" exact element={<Ranking />} />
          <Route path="/precos" exact element={<Precos />} />
          <Route path="/politica-de-privacidade" exact element={<PoliticaPrivacidade />} />
          <Route path="/exclusao-de-conta" exact element={<ExclusaoConta />} />

          <Route element={<PrivateRoute />}>
            <Route path="/perfil" exact element={<Perfil />} />
          </Route>
        </Routes>
      </div>
    </>
  )
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppLayout />
      </UserProvider>
    </Router>
  )
}

export default App
